enum Process {
	COUNTRY_PROMOTIONS = 'COUNTRY_PROMOTIONS',
	HOTEL_INFO = 'HOTEL_INFO',
	HOTEL_ROOM_ENRICHMENT = 'HOTEL_ROOM_ENRICHMENT',
	COMPANY_HOTEL_MARKET_STATE = 'COMPANY_HOTEL_MARKET_STATE',
	COMPANY_HOTEL_MARKET_STATE_OTA = 'COMPANY_HOTEL_MARKET_STATE_OTA',
	HOTEL_RANKING = 'HOTEL_RANKING',
	HOTEL_REVIEWS = 'HOTEL_REVIEWS',
	PMS_API_DATA = 'PMS_API_DATA',
	ACTIVATE_PROVIDER = 'ACTIVATE_PROVIDER',
	OTA_PRICES_UPDATE = 'OTA_PRICES_UPDATE',
	MARKET_AREA_STATE = 'MARKET_AREA_STATE',
	METARADAR = 'METARADAR',
	PRICE_RECOMMENDATION = 'PRICE_RECOMMENDATION',
}

export default Process;
